var _defs, _rect, _g, _g2, _rect2, _rect3, _tspan, _path, _rect4, _tspan2, _path2, _rect5, _rect6, _tspan3, _path3, _rect7, _tspan4, _path4, _rect8, _tspan5, _path5, _rect9, _tspan6, _path6, _rect0, _tspan7, _path7, _g3, _rect1, _rect10, _tspan8, _path8, _rect11, _tspan9, _path9, _rect12, _rect13, _rect14, _rect15, _tspan0, _tspan1, _tspan10, _g4, _tspan11, _rect16, _rect17, _rect18, _rect19, _tspan12, _tspan13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 312,
    viewBox: "0 0 472 312",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_f2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 312,
    rx: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11512_2147_f2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 1971,
    width: 472,
    height: 312,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_11512_2147_f2",
    x: 755.391,
    y: 2099,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_11512_2147_f2",
    x: 1008.39,
    y: 2011,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_11512_2147_f2",
    x: 742.391,
    y: 2173,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_11512_2147_f2",
    x: 1123.89,
    y: 2196.02,
    width: 38.936,
    height: 30.9077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_11512_2147_f2",
    x: 969.391,
    y: 2163,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_11512_2147_f2",
    x: 812.391,
    y: 2222,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_11512_2147_f2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11512_2147_f2",
    transform: "matrix(0.000660834 0 0 0.000751599 -0.33757 -0.238115)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_11512_2147_f2",
    x: 729,
    y: 1969,
    width: 474,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.29293 0 0 0 0 0.353365 0 0 0 0 0.257379 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_11512_2147_f2",
    x: 1095.39,
    y: 2035,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_11512_2147_f2",
    x: 658.7,
    y: 1841.7,
    width: 288.6,
    height: 288.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_11512_2147_f2",
    x: 1013.7,
    y: 2085.7,
    width: 349.6,
    height: 349.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_11512_2147_f2",
    x: 1022.39,
    y: 2087,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_11512_2147_f2",
    x: 1114.39,
    y: 2101,
    width: 38.936,
    height: 26.6618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00998
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11512_2147_f2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9375,
    height: 25.9375,
    fill: "white",
    transform: "translate(871 2149)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11512_2147_f2",
    "data-name": "image.png",
    width: 3556,
    height: 1544,
    preserveAspectRatio: "none",
    href: "/feature-art-image0.jpg"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_11512_2147_f2",
    x: 960,
    y: 2207,
    width: 144,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_11512_2147_f2",
    x: 918,
    y: 2165,
    width: 228,
    height: 186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_11512_2147_f2",
    x: 752,
    y: 1906,
    width: 266,
    height: 213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11512_2147_f2",
    x1: 946.839,
    y1: 2149.63,
    x2: 946.839,
    y2: 2028.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F8F12"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_11512_2147_f2",
    x: 794,
    y: 1948,
    width: 180,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-731 -1971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 784_f2",
    filter: "url(#filter18_i_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11512_2147_f2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 1971,
    width: 472,
    height: 312,
    rx: 24,
    fill: "#17270D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_3_f2",
    opacity: 0.38,
    filter: "url(#filter19_f_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 1986,
    r: 53,
    fill: "#43B017"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_2_f2",
    opacity: 0.24,
    filter: "url(#filter20_f_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1188.5,
    cy: 2260.5,
    r: 83.5,
    fill: "#43B017"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 10_2_f2"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "image 58_2_f2",
    x: 707.324,
    y: 1995.32,
    width: 471.352,
    height: 414.352,
    rx: 9.67578,
    fill: "url(#pattern1_11512_2147_f2)",
    stroke: "#DAE4D5",
    strokeWidth: 0.648437
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 442_2_f2",
    filter: "url(#filter21_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_10_f2"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1126.5,
    y: 2201.2,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#C13A4A"
  })), /*#__PURE__*/React.createElement("text", {
    id: "875K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1134.36,
    y: 2211.28
  }, "875K")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_10_f2",
    d: "M1143.73 2221.1L1140.22 2216.08L1147.25 2216.08L1143.73 2221.1Z",
    fill: "#C13A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 19_2_f2",
    filter: "url(#filter22_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_11_f2"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 2099,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#3FAE16"
  })), /*#__PURE__*/React.createElement("text", {
    id: "675K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 765.859,
    y: 2109.08
  }, "675K")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_11_f2",
    d: "M774.859 2120.04L771.348 2115.03L778.371 2115.03L774.859 2120.04Z",
    fill: "#3FAE16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 448_2_f2",
    filter: "url(#filter23_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_12_f2"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 815.648,
    y: 2222.65,
    width: 32.4219,
    height: 14.7297,
    rx: 7.36486,
    fill: "#E8B611"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 815.648,
    y: 2222.65,
    width: 32.4219,
    height: 14.7297,
    rx: 7.36486,
    stroke: "#E8B611",
    strokeWidth: 1.29688
  })), /*#__PURE__*/React.createElement("text", {
    id: "365K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 822.859,
    y: 2232.08
  }, "365K")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_12_f2",
    d: "M831.859 2243.04L828.348 2238.03L835.371 2238.03L831.859 2243.04Z",
    fill: "#E8B611"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 445_4_f2",
    filter: "url(#filter24_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_13_f2"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1098,
    y: 2035,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#C13A4A"
  })), /*#__PURE__*/React.createElement("text", {
    id: "515K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1106.36,
    y: 2045.08
  }, "515K")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_13_f2",
    d: "M1114.86 2056.04L1111.35 2051.03L1118.37 2051.03L1114.86 2056.04Z",
    fill: "#C13A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 451_2_f2",
    filter: "url(#filter25_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_14_f2"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1117,
    y: 2101,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#3FAE16"
  })), /*#__PURE__*/React.createElement("text", {
    id: "725K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 1124.86,
    y: 2111.08
  }, "725K")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_14_f2",
    d: "M1133.86 2122.04L1130.35 2117.03L1137.37 2117.03L1133.86 2122.04Z",
    fill: "#3FAE16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 440_2_f2",
    filter: "url(#filter26_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_15_f2"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 745,
    y: 2173,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#C13A4A"
  })), /*#__PURE__*/React.createElement("text", {
    id: "849K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 752.359,
    y: 2183.08
  }, "849K")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_15_f2",
    d: "M761.859 2194.04L758.348 2189.03L765.371 2189.03L761.859 2194.04Z",
    fill: "#C13A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 447_2_f2",
    filter: "url(#filter27_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_16_f2"
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1011,
    y: 2011,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#3FAE16"
  })), /*#__PURE__*/React.createElement("text", {
    id: "330K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 1018.86,
    y: 2021.08
  }, "330K")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_16_f2",
    d: "M1027.86 2032.04L1024.35 2027.03L1031.37 2027.03L1027.86 2032.04Z",
    fill: "#3FAE16"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "subject-property-marker_2_f2",
    clipPath: "url(#clip6_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_f2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5_f2",
    d: "M883.969 2149C881.39 2149 878.918 2150.03 877.095 2151.85C875.271 2153.68 874.246 2156.15 874.242 2158.73C874.242 2165.71 883.304 2174.46 883.689 2174.82C883.764 2174.9 883.864 2174.94 883.969 2174.94C884.073 2174.94 884.174 2174.9 884.248 2174.82C884.633 2174.46 893.695 2165.71 893.695 2158.73C893.692 2156.15 892.666 2153.68 890.843 2151.85C889.019 2150.03 886.547 2149 883.969 2149Z",
    fill: "#17270D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S_2_f2",
    d: "M884.112 2163.42C883.654 2163.42 883.226 2163.36 882.828 2163.25C882.431 2163.14 882.076 2162.98 881.765 2162.79C881.454 2162.58 881.194 2162.35 880.987 2162.1C880.788 2161.85 880.658 2161.58 880.598 2161.31L882.335 2160.79C882.448 2161.08 882.647 2161.34 882.932 2161.55C883.217 2161.76 883.576 2161.87 884.008 2161.88C884.467 2161.89 884.838 2161.79 885.124 2161.58C885.418 2161.37 885.565 2161.1 885.565 2160.78C885.565 2160.49 885.448 2160.25 885.215 2160.06C884.99 2159.86 884.678 2159.71 884.281 2159.61L883.101 2159.3C882.66 2159.18 882.271 2159.02 881.933 2158.79C881.596 2158.56 881.333 2158.27 881.142 2157.93C880.952 2157.6 880.857 2157.2 880.857 2156.75C880.857 2155.9 881.138 2155.23 881.7 2154.76C882.271 2154.27 883.075 2154.03 884.112 2154.03C884.691 2154.03 885.197 2154.12 885.63 2154.29C886.07 2154.45 886.438 2154.69 886.732 2155C887.026 2155.32 887.251 2155.68 887.406 2156.11L885.681 2156.64C885.578 2156.34 885.387 2156.09 885.111 2155.89C884.834 2155.68 884.484 2155.57 884.06 2155.57C883.628 2155.57 883.287 2155.67 883.036 2155.87C882.794 2156.07 882.673 2156.35 882.673 2156.72C882.673 2157 882.768 2157.23 882.958 2157.39C883.157 2157.55 883.425 2157.68 883.762 2157.77L884.955 2158.06C885.733 2158.25 886.338 2158.6 886.771 2159.09C887.203 2159.58 887.419 2160.13 887.419 2160.74C887.419 2161.27 887.29 2161.74 887.03 2162.15C886.771 2162.55 886.395 2162.86 885.902 2163.08C885.409 2163.31 884.813 2163.42 884.112 2163.42Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 452_3_f2",
    filter: "url(#filter28_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_17_f2"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1025.65,
    y: 2087.65,
    width: 32.4219,
    height: 14.7297,
    rx: 7.36486,
    fill: "#E8B611"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1025.65,
    y: 2087.65,
    width: 32.4219,
    height: 14.7297,
    rx: 7.36486,
    stroke: "#E8B611",
    strokeWidth: 1.29688
  })), /*#__PURE__*/React.createElement("text", {
    id: "420K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 1032.36,
    y: 2097.08
  }, "420K")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_17_f2",
    d: "M1041.86 2108.04L1038.35 2103.03L1045.37 2103.03L1041.86 2108.04Z",
    fill: "#E8B611"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 452_4_f2",
    filter: "url(#filter29_d_11512_2147_f2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_18_f2"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 972,
    y: 2163,
    width: 33.7188,
    height: 16.0266,
    rx: 8.0133,
    fill: "#3FAE16"
  })), /*#__PURE__*/React.createElement("text", {
    id: "580K_2_f2",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.13281,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 979.359,
    y: 2173.08
  }, "580K")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_18_f2",
    d: "M988.859 2184.04L985.348 2179.03L992.371 2179.03L988.859 2184.04Z",
    fill: "#3FAE16"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-731 -1971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 22_f2",
    filter: "url(#filter30_d_11512_2147_f2)",
    "data-figma-bg-blur-radius": 4
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 1946,
    width: 186,
    height: 133,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 1946.25,
    width: 185.5,
    height: 132.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 23_f2",
    filter: "url(#filter31_d_11512_2147_f2)"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 1958,
    width: 160,
    height: 109,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arv-estimate_f2"
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 1970,
    width: 147,
    height: 85,
    rx: 4.07273,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_f2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ARV Estimate_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 855,
    y: 1987.4
  }, "ARV Estimate")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 437_f2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9_f2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$332K_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.61818,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 823.4,
    y: 2042.21
  }, "$332K"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 703_f2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$346K_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 857.153,
    y: 2019.84
  }, "$346K")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8_f2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 376_f2",
    x: 944.802,
    y: 2028.62,
    width: 4.07273,
    height: 121.005,
    rx: 2.03637,
    transform: "rotate(90 944.802 2028.62)",
    fill: "url(#paint0_linear_11512_2147_f2)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "$360K_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.61818,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 925.719,
    y: 2042.21
  }, "$360K")))))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 783_f2",
    filter: "url(#filter32_d_11512_2147_f2)",
    "data-figma-bg-blur-radius": 4
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 958,
    y: 2205,
    width: 148,
    height: 106,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 958.25,
    y: 2205.25,
    width: 147.5,
    height: 105.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 23_2_f2",
    filter: "url(#filter33_d_11512_2147_f2)"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 2217,
    width: 124,
    height: 82,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arv-estimate_2_f2"
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 977,
    y: 2229,
    width: 110,
    height: 58,
    rx: 4.07273,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_2_f2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Median DOM_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 1004.5,
    y: 2244.11
  }, "Median DOM")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 437_2_f2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9_2_f2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 703_2_f2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "51_f2",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1022.91,
    y: 2276.55
  }, "51")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature-2.793b214ba940473da83a7aa0109103e8.svg";
export { ForwardRef as ReactComponent };